export enum ScheduleStatusEnum {
    NotYetDue = 1,
    NotStarted = 2,
    Saved = 3,
    SubmittedCoSignature = 4,
    SubmittedWithSignature = 5, // Also known as pending QA
    ExportReady = 6,
    Exported = 7,
    ToBeSent = 8,
    SentToPhysician = 9,
    ReturnedWithPhysicianSignature = 10,
    Completed = 11,
    Returned = 12,
    Reopened = 13,
    NotExported = 14,
    Created = 15,
    PendingAddendum = 16,
    ProcessingSubmission = 17,
    OrderReceived = 18,
    Errored = 19
}
